import React from "react";
import Tilty from "react-tilty";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const BcrumbBannerOne = ({ title, paragraph, styleClass, mainThumb }) => {
  return (
    <div className="breadcrum-area breadcrumb-banner">
      <div className="container">
        <div className="section-heading heading-left">
          <h1
            className="title h2"
            dangerouslySetInnerHTML={{ __html: title }}
          ></h1>
          <p dangerouslySetInnerHTML={{ __html: paragraph }}></p>
          <div>
            <Link
              to={process.env.PUBLIC_URL + "/subscription"}
              className="axil-btn btn-primary try-free-btn btn-large"
            >
              Get Started Now
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="decoration-elements position-absolute w-100 h-100 top-0 start-0">
        <div
          className="shape shape-1 position-absolute"
          style={{
            top: "15%",
            left: "5%",
            animation: "float 6s ease-in-out infinite",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "rgba(102, 0, 204, 0.1)",
            }}
          ></div>
        </div>
        <div
          className="shape shape-2 position-absolute"
          style={{
            bottom: "10%",
            right: "10%",
            animation: "float 8s ease-in-out infinite 1s",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              background: "rgba(102, 0, 204, 0.08)",
            }}
          ></div>
        </div>
        <div className={`banner-thumbnail ${styleClass}`}>
          <img src={process.env.PUBLIC_URL + mainThumb} alt="Illustration" />
        </div>
        <div
          className="line-shape position-absolute"
          style={{
            top: "50%",
            left: "-5%",
            right: "-5%",
            height: "1px",
            background:
              "linear-gradient(90deg, transparent, rgba(102, 0, 204, 0.2), transparent)",
            transform: "rotate(-5deg)",
          }}
        ></div>
      </div>

      {/* Add custom CSS for animations */}
      <style jsx>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(102, 0, 204, 0.4) !important;
          transition: all 0.3s ease;
        }

        .banner-image {
          transition: all 0.5s ease;
        }

        .banner-image:hover {
          transform: scale(1.02);
        }
      `}</style>
    </div>
  );
};

export default BcrumbBannerOne;